// extracted by mini-css-extract-plugin
export default {"external":"azcqGv","icon":"bzcqGv","dropdown":"czcqGv","resultList":"dzcqGv"};